package nacholab.supplies.i18n

class SpanishStrings : Strings {
    override val code = "en"

    override val strings = hashMapOf(
        "appTitle" to "Nacholab's Supplies",

        "authenticate_gplay_getinon" to "DESCARGALA DE",
        "authenticate_gplay_gplay" to "Google Play",
        "authenticate_instructions" to "Ingresá tu dirección de correo electrónico. Vas a recibir un código para poder acceder a tus insumos.",
        "authenticate_enter" to "Ingresar!",

        "verifycode_instructions" to "Ingresá el código de verificación que enviamos a tu dirección de correo electrónico",

        "supplylist_name" to "Nombre",
        "supplylist_stock" to "Stock",
        "supplylist_location" to "Ubicación",
        "supplylist_current" to "Actual",
        "supplylist_required" to "Requerido",
        "supplylist_home" to "Casa",
        "supplylist_market" to "Supermercado",

        "addsupply_title" to "Agregar nuevo insumo",
        "addsupply_name" to "Nombre",
        "addsupply_homeLocation" to "Ubicación en la casa",
        "addsupply_marketLocation" to "Ubicación en el supermercado",
        "addsupply_stock" to "Stock",
        "addsupply_cancel" to "Cancelar",
        "addsupply_save" to "Guardar",
    )

    override val months = arrayOf(
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
    )

}